import i18n from '../i18n';

/** Plain-language reasons shown beside locked enrollment fields on edit. */
export const ENROLLMENT_LOCK_REASONS = {
    get student() {
        return i18n.t('enrollments.lockReasons.student');
    },
    get level() {
        return i18n.t('enrollments.lockReasons.level');
    },
    get batch() {
        return i18n.t('enrollments.lockReasons.batch');
    },
    get startDate() {
        return i18n.t('enrollments.lockReasons.startDate');
    },
    get endDateEditable() {
        return i18n.t('enrollments.lockReasons.endDateEditable');
    },
    get carryForward() {
        return i18n.t('enrollments.lockReasons.carryForward');
    },
    get carryForwardBatch() {
        return i18n.t('enrollments.lockReasons.carryForwardBatch');
    },
    get billingMode() {
        return i18n.t('enrollments.lockReasons.billingMode');
    },
    get billingAmount() {
        return i18n.t('enrollments.lockReasons.billingAmount');
    },
    get customRateEditable() {
        return i18n.t('enrollments.lockReasons.customRateEditable');
    },
    get customRateLocked() {
        return i18n.t('enrollments.lockReasons.customRateLocked');
    },
    get discount() {
        return i18n.t('enrollments.lockReasons.discount');
    },
    get systemManaged() {
        return i18n.t('enrollments.lockReasons.systemManaged');
    },
};

export function canEditEnrollmentField(field, ctx) {
    const { isEdit, systemManaged, hasCustomSessionRate } = ctx;
    if (!isEdit) return true;
    if (systemManaged) return false;
    if (field === 'endDate') return true;
    if (field === 'overridePerSessionCharge') return hasCustomSessionRate;
    return false;
}

export function buildEnrollmentUpdateBody({
    studentId,
    levelId,
    batchId,
    enrolledDateISO,
    endEnrollmentDateISO,
    overrideCarryForward,
    discountId,
    overrideChargesMode,
    overridePerSessionCharge,
    overridePeriodCharge,
    overridePeriodInterval,
    showOverrideCharges,
}, ctx) {
    const base = {
        studentId: Number(studentId),
        levelId: Number(levelId),
        batchId: Number(batchId),
        enrolledDate: enrolledDateISO,
        endEnrollmentDate: endEnrollmentDateISO || null,
    };

    if (!ctx.isEdit) {
        const body = {
            ...base,
            discountId: discountId ? Number(discountId) : null,
        };
        if (overrideCarryForward !== null && overrideCarryForward !== undefined) {
            body.overrideCarryForward = overrideCarryForward;
        }
        if (showOverrideCharges) {
            body.overrideChargesMode = overrideChargesMode || null;
            if (overrideChargesMode === "PER_PERIOD") {
                body.overridePeriodCharge = overridePeriodCharge ? Number(overridePeriodCharge) : null;
                body.overridePeriodInterval = overridePeriodInterval || null;
            } else {
                body.overridePerSessionCharge = overridePerSessionCharge ? Number(overridePerSessionCharge) : null;
            }
        }
        return body;
    }

    if (ctx.systemManaged) {
        return { endEnrollmentDate: endEnrollmentDateISO || null };
    }

    const body = {
        endEnrollmentDate: endEnrollmentDateISO || null,
    };

    if (ctx.hasCustomSessionRate && overridePerSessionCharge) {
        body.overridePerSessionCharge = Number(overridePerSessionCharge);
        body.overrideChargesMode = overrideChargesMode || null;
    }

    return body;
}

export function enrollmentApiBase(role) {
    const r = (role || 'ADMIN').toUpperCase();
    if (r === 'MANAGER') return '/manager/enrollments';
    if (r === 'COACH') return '/coach/enrollments';
    return '/admin/enrollments';
}
